import { DoneOutline } from "@mui/icons-material";
import React from "react";

const SplitMessage = () => {
    return <div className="icon-text">
        <DoneOutline style={{ color: "#27AE60" }} />
        <p style={{ marginLeft: "10px" }}>Document Splitted Successfully</p>
    </div>
}

export default SplitMessage;